import Client from '../Client';

export default class EmailTemplate {
  /**
   * @param {Client} Client - Instance of Client
   * @param {Object} APIEmailTemplate - containing the server side object
   */
  constructor(
    Client,
    { id, name, subject, content, building_id, created, modified }
  ) {
    if (!Client) throw new Error('Please provide an instance of Client');
    const { parseISODateTimeAsUTC } = Client;

    this.Client = Client;
    Object.defineProperty(this, 'Client', { enumerable: false });

    this.id = id || 0;
    this.name = name || '';
    this.subject = subject || '';
    this.content = content || '';
    this.building_id = building_id || null;

    this.created = parseISODateTimeAsUTC(created);
    this.modified = parseISODateTimeAsUTC(modified);
  }
}
